<template>
    <b-modal ref="reschedule-modal"
             size="lg"
             :title="`${trans('tasks.actions.reestimate')} | ${trans('tasks.actions.initial_estimate')} ${newTimeEstimated}`"
             no-close-on-backdrop
             no-close-on-esc
             hide-header-close>
        <template #default>
            <form v-debounce ref="form">
                <reschedule-form :new-time-estimated="newTimeEstimated"
                                 :input-errors="messages.validation"
                                 @newTimeEstimated="setNewTimeEstimated"
                />
            </form>
        </template>
        <template #modal-footer class="text-right">
            <button type="submit" class="btn btn-success" @click="submit">{{ trans('common.actions.save') }}</button>
            <button type="button" class="btn btn-light" @click="cancel">{{ trans('common.actions.cancel') }}</button>
        </template>
    </b-modal>
</template>

<script>

import {mapState, mapActions} from 'vuex';

import RescheduleForm from '@/views/Tasks/Reschedule/Partials/Form';

import TaskWorkLogController from '@/services/Tasks/TaskWorkLogController';

export default {

    props: ['task_id', 'remainingWork', 'timeEstimated', 'additionalTime'],

    components: {RescheduleForm},

    data() {
        return {
            newTimeEstimated: null,
        };
    },

    mounted() {
        this.showModal();

        const params = {
            previous_time_estimation: this.timeEstimated,
            additional_time: this.additionalTime,
        };

        TaskWorkLogController.calculateNewTimeEstimation(params).then((response) => {
            this.newTimeEstimated = response.data;
        });
    },

    computed: {

        ...mapState(['messages']),
    },

    methods: {

        ...mapActions(['resetMessages']),

        submit() {
            const params = {
                new_time_estimated: this.newTimeEstimated,
                task_id: this.task_id,
            };

            TaskWorkLogController.saveTimeEstimation(params).then(() => {
                this.resetMessages();

                this.$emit('saved');

                this.hideModal();
            }).catch(() => {
                // nothing to do
            }).finally(() => {
                this.formSubmitHideWait(this.$refs.form);
            });
        },

        cancel() {
            this.$emit('cancel');
            this.hideModal();
        },

        showModal() {
            this.$refs['reschedule-modal'].show();
            this.$emit('shown');
        },

        hideModal() {
            this.$refs['reschedule-modal'].hide();
            this.$emit('hidden');
        },

        setNewTimeEstimated(newTimeEstimated) {
            this.newTimeEstimated = newTimeEstimated;
        },

    }

};

</script>



// WEBPACK FOOTER //
// src/views/Tasks/Task/Partials/Show/RescheduleModal.vue